import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { DadosAutoriaModel } from './dados-autoria.model';

@Injectable()
export class DadosAutoriaService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient) { }

  adicionarDadosAutoria(dadosAutoria): Observable<DadosAutoriaModel> {
    return this.httpClient.post<DadosAutoriaModel>(this.apiURL + '/propriedade-autoria', dadosAutoria, this.httpOptions);
  }

  buscarDadosAutoriaPorCliente(clienteId: Number): Observable<DadosAutoriaModel> {
    return this.httpClient.get<DadosAutoriaModel>(this.apiURL + `/propriedade-autoria/${clienteId}`, this.httpOptions);
  }

  buscarRegras(): Observable<any> {
    return this.httpClient.get<any>(this.apiURL + `/propriedade-autoria/regras`, this.httpOptions);
  }

  buscarPropriedadeByPropAndCliente(propId, clienteId): Observable<DadosAutoriaModel> {
    return this.httpClient.get<DadosAutoriaModel>(this.apiURL + `/propriedade-autoria/${propId}/${clienteId}`, this.httpOptions);
  }

  editarDadosAutoriaPorCliente(dadosAutoria): Observable<DadosAutoriaModel> {
    return this.httpClient.put<DadosAutoriaModel>(this.apiURL + '/propriedade-autoria', dadosAutoria, this.httpOptions);
  }

  apagarDadosAutoriaPorCliente(clienteId: Number) {
    const headers = new HttpHeaders()
    .set('ticket', sessionStorage.getItem('ticket-ECM'))
    .set('Authorization', sessionStorage.getItem('tokenAuth'));
    return this.httpClient.delete(this.apiURL + `/propriedade-autoria/${clienteId}`, { headers, responseType: 'text' });
  }

}



// WEBPACK FOOTER //
// /app/src/app/dados-autoria/dados-autoria.service.ts